module.exports = __webpack_public_path__ + "img/laptop.fee6ec07.png";